import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Drawer,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
  colors,
} from "@mui/material";
import React, { useEffect, useState } from "react";

//table
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";

//table end
import InboxIcon from "@mui/icons-material/MoveToInbox";
import MailIcon from "@mui/icons-material/Mail";

import MenuIcon from "@mui/icons-material/Menu";
import Leo from "./../../assets/images/Leo.png";
import restaurant from "./../../assets/images/Restaurant.jpg";
import resBlack from "./../../assets/icons/restaurantBlack.png";
import productBlack from "./../../assets/icons/product (1).png";
import empBlack from "./../../assets/icons/Emp.png";
import menu from "./../../assets/images/Menu.png";
import "./LandingPage.css";
import { useNavigate } from "react-router-dom";
import restaurantIcon from "./../../assets/icons/restaurantBlack.png";
import menu3 from "./../../assets/icons/menu.png";
import order from "./../../assets/icons/cargo.png";
import orderHistory from "./../../assets/icons/order-history.png";
import delivery from "./../../assets/icons/delivery.png";
import settings from "./../../assets/icons/settings.png";
import item from "./../../assets/icons/Item.png";
import SideBar from "../layouts/sidebar/SideBar.tsx";
import TopHeader from "../../components/TopHeader.tsx";
import AutoCompleteMultiSelect from "../components/AutoCompleteMultiselect/AutoCompleteMultiSelect.tsx";
import axios from "axios";
import jwt_decode from "jwt-decode";
import { useDispatch, useSelector } from "react-redux";
import { NotificationState } from "../../reduxadmin/Reducers/Interface/Interface.tsx";
import NavigationCard from "./components/NavigationCard.tsx";

type Anchor = "top" | "left" | "bottom" | "right";

//table start
interface Column {
  id: "orderid" | "customername" | "foodname" | "quantity" | "price" | "button";
  label: string;
  minWidth?: number;
  align?: "right";
  format?: (value: number) => string;
}

const columns: readonly Column[] = [
  { id: "orderid", label: "OrderId", minWidth: 100 },
  { id: "customername", label: "CutomerName", minWidth: 100 },
  {
    id: "foodname",
    label: "FoodName",
    minWidth: 170,
    align: "right",
    // format: (value: number) => value.toLocaleString('en-US'),
  },
  {
    id: "quantity",
    label: "Quantity",
    minWidth: 100,
    align: "right",
    // format: (value: number) => value.toLocaleString('en-US'),
  },
  {
    id: "price",
    label: "Price",
    minWidth: 100,
    align: "right",
    // format: (value: number) => value.toFixed(2),
  },
  { id: "button", label: "Action", minWidth: 170 },
];

// interface Data {
//   orderid: string;
//   customername: string;
//   foodname: number;
//   quantity: number;
//   price: number;
//   button:any
// }

function createData(
  orderid: string,
  customername: string,
  foodname: string,
  quantity: number,
  price: number
) {
  return { orderid, customername, foodname, quantity, price };
}

const rows = [
  createData("B10101", "Leo", "Burger", 3, 1500),
  createData("B10101", "Leo", "Burger", 3, 1500),
  createData("B10101", "Leo", "Burger", 3, 1500),
  createData("B10101", "Leo", "Burger", 3, 1500),
  createData("B10101", "Leo", "Burger", 3, 1500),
  createData("B10101", "Leo", "Burger", 3, 1500),
  createData("B10101", "Leo", "Burger", 3, 1500),
  createData("B10101", "Leo", "Burger", 3, 1500),
];

//table end

function LandingPage() {
  const apiAddress = process.env.REACT_APP_SECRET;

  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  const toggleDrawer =
    (anchor: Anchor) => (event: React.KeyboardEvent | React.MouseEvent) => {
      if (
        event.type === "keydown" &&
        ((event as React.KeyboardEvent).key === "Tab" ||
          (event as React.KeyboardEvent).key === "Shift")
      ) {
        return;
      }

      setState((prevState) => ({
        ...prevState,
        [anchor]: !prevState[anchor],
      }));
    };
  const navigate = useNavigate();
  const clickMenuList = (props) => {
    console.log("props: " + props);
    if (props === "Manage restaurant") {
      navigate("/restaurant-setup");
    } else if (props === "Manage Product") {
      navigate("/manage-product");
    }
  };

  //table start

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  //table end

  //for notification
  const dispatch = useDispatch();
  const total_notification = useSelector(
    (state: NotificationState) => state.totalNotification.totalNotification
  );

  const [open, setOpen] = React.useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if ((reason && reason == "backdropClick") || reason == "escapeKeyDown")
      return;
    setOpen(false);
  };

  const getUserRolesInfo = async (userId, restaurantId) => {
    const response = await axios.get(
      `${process.env.REACT_APP_SECRET}/api/RolesAndPermissions?userId=${userId}&restaurantId=${restaurantId}`
    );
    console.log("test6", response);
    return response.data;
  };

  const addRestaurant = (props) => {
    console.log(props);
    restaurantList.map((data, index) => {
      if (data.title == props) {
        console.log("test2", data);
        var obj = { id: data.id, name: data.title, imgUrl: data.imgUrl };

        localStorage.setItem("parentrestaurant", JSON.stringify(obj));
        localStorage.setItem("restaurant", JSON.stringify(obj));
        localStorage.setItem("restaurantChanged", "newRestaurantSeelected");

        const permission = localStorage.getItem("permissions");

        const currentRestaurant = localStorage.getItem("restaurant");
        const currentRestaurantObj = JSON.parse(currentRestaurant);

        if (permission !== null) {
          getUserRolesInfo(userid, currentRestaurantObj.id).then((data) => {
            localStorage.removeItem("permissions");
            localStorage.setItem("permissions", JSON.stringify(data));
            console.log("props: ", JSON.stringify(data));
          });
        } else {
          getUserRolesInfo(userid, currentRestaurantObj.id).then((data) => {
            localStorage.setItem("permissions", JSON.stringify(data));
            console.log("props: ", JSON.stringify(data));
          });
        }

        // Broadcast the change to other tabs
        const broadcastChannel = new BroadcastChannel("storage_change_channel");
        broadcastChannel.postMessage("restaurantChanged");

        window.dispatchEvent(new Event("storage"));
      }
    });
    setOpen(false);
  };
  const permission = localStorage.getItem("permissions");

  console.log("permission", permission);

  // useEffect(()=>{

  // })
  const [userid, setUserId] = useState("");
  const [userRole, setUserRole] = useState("");
  const [restaurantList, setRestaurantList] = useState([]);
  console.log("decodedData", userRole, userid);
  console.log("test3", restaurantList);
  useEffect(() => {
    const token = localStorage.getItem("gotasteadmintoken");

    var decodedData = {};
    if (token != null) {
      try {
        decodedData = jwt_decode(token);

        console.log(decodedData.UserId);
        setUserId(decodedData.UserId);
        setUserRole(decodedData.UserRole);
        console.log(userid);

        // setTokenData(decodedData)
      } catch (error) { }
    }

    console.log("useEffect called");
    const Restauranttoken = localStorage.getItem("restaurant");
    console.log(Restauranttoken);
    if (Restauranttoken) {
      setOpen(false);
    } else {
      axios
        .get(
          apiAddress +
          "/api/RestaurantUserMapper/getbyuserid/" +
          decodedData.UserId
        )
        .then((response) => {
          console.log(response.data);
          if (response.data.length > 0) {
            setOpen(true);
            var list = [];
            response.data.map((dt, i) => {
              var obj = {
                id: dt.restaurantId,
                title: dt.restaurantName,
                imgUrl: dt.imgUrl,
                img: dt.imgUrl,
              };
              list.push(obj);
            });
            setRestaurantList(list);
          } else {
            var obj = {
              id: response.data[0].restaurantId,
              name: response.data[0].restaurantName,
              imgUrl: response.data[0].imgUrl,
              img: response.data[0].imgUrl,
            };
            console.log("test4", obj);
            localStorage.setItem("restaurant", JSON.stringify(obj));
            setOpen(false);
          }
        });
    }
  }, []);

  useEffect(() => {
    if (restaurantList.length === 1) {
      addRestaurant(restaurantList[0].title);
    }
  }, [restaurantList]);

  return (
    <>
      <TopHeader />

      <Dialog fullWidth={true} open={open} onClose={handleClose}>
        <DialogTitle>
          <div className="d-flex justify-content-center align-items-center">
            Select your restaurant
          </div>
        </DialogTitle>
        <DialogContent>
          {/* <Grid container >
                <Grid item xs={12} sx={{padding:'0.5rem'}}>
                    <Typography >
                        Select your restaurant
                    </Typography>
                </Grid>
        </Grid> */}
          {/* <Grid container >
            <Grid item xs={12} sx={{ padding: '0.5rem' }}>
              <AutoCompleteMultiSelect
                label={"Restaurant name"}
                placeholder={'Restaurant name'}
                value={addRestaurant}
                datas={restaurantList}
                id={1}
              />

            </Grid>

          </Grid> */}
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ flexWrap: "wrap", gap: "20px" }}
          >
            {restaurantList.map((dt, i) => {
              return (
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{
                    flexDirection: "column",
                    borderRadius: "10px",
                    padding: "5px",
                    boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                    maxWidth: "10rem",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    addRestaurant(dt.title);
                  }}
                >
                  {dt.img == "" ? (
                    <img
                      src={restaurantIcon}
                      alt=""
                      style={{ width: "2rem" }}
                    />
                  ) : (
                    <img src={dt.img} alt="" style={{ width: "2rem" }} />
                  )}
                  <p className="pb-0 pt-1 mb-0">{dt.title}</p>
                </div>
              );
            })}
          </div>
        </DialogContent>
        <DialogActions>
          {/* <Button onClick={handleClose}>Close</Button> */}
        </DialogActions>
      </Dialog>

      <div className="row">
        <div className="col-2"></div>
        <div className="col-8 mt-3">
          <h2>Getting started</h2>
        </div>
        <div className="col-2"></div>
      </div>

      <div className="row">
        <div className="col-2"></div>
        <div className="col-8" style={{ marginTop: "2rem" }}>
          <div
            className="d-flex justify-content-center flex-wrap"
            style={{ gap: "10px" }}
          >
            <NavigationCard
              Icon={restaurantIcon}
              total_notification={total_notification}
              RedirectLocation={"/restaurant-setup"}
              Title={"Restaurant"}
              Description={"Manage , create, update restaurant here"}
              FooterText={"Create restaurant"}
              UsedFor="Restaurant"
            />

            <div
              className="discountImage cardGap mt-5"
              onClick={() => {
                window.location.href = "/manage-product";
              }}
            >
              {/* <img src={menu} alt="" className="img-fluid image-Discount" /> */}
              <div className="discountOfferDiv ">
                <div className="discountOfferDivDetails ">
                  <div className="offer-Text">
                    {/* <h2><b>Create menu</b></h2> */}
                  </div>
                </div>
              </div>
              <div>
                <div className="CardTitle" style={{ right: "40%" }}>
                  <h5>Menu</h5>
                </div>
                <div className="CardDetails">
                  <p>Manage , create, update menu here</p>
                </div>
                <div className="iconPosition" style={{ top: "-18%" }}>
                  <div className="circle">
                    <img
                      src={menu3}
                      alt="icon"
                      style={{ width: "3rem", height: "3rem" }}
                    />
                  </div>
                </div>
                <div className="d-flex justify-content-center cardButton">
                  <h6>Create menu</h6>
                </div>
              </div>
            </div>

            {/* <div
              className="discountImage mt-5"
              onClick={() => {
                window.location.href = "/orders";
              }}
            >
              <div className="discountOfferDiv ">
                <div className="discountOfferDivDetails ">
                  <div className="offer-Text">
                  </div>
                </div>
              </div>
              <div className="CardTitle d-flex flex-row justify-content-center" style={{ width: '100%' }}>
                <h5>Kitchens</h5>
              </div>
              <div className="CardDetails">
                <p>Manage , and view kitchens here</p>
              </div>
              <div className="iconPosition" style={{ top: "-18%" }}>
                <div className="circle">
                  <img
                    src={order}
                    alt="icon"
                    style={{ width: "3rem", height: "3rem" }}
                  />
                </div>
              </div>
              <div className="d-flex justify-content-center cardButton">
                <h6>Create item</h6>
              </div>
            </div> */}

            {/* <NavigationCard
              Icon={orderHistory}
              total_notification={total_notification}
              RedirectLocation={"/order-history-log"}
              Title={"Transactions Log"}
              Description={"Refund , Withdraw, Check transaction log here"}
              FooterText={"Refund, Withdraw & Statement"}
              UsedFor="OrderHistoryLog"
            /> */}

            {/* <div className="discountImage  mt-5" onClick={() => { navigate("/admin-settings") }}>

             
              <div className="discountOfferDiv ">
                <div className="discountOfferDivDetails ">
                  <div className='offer-Text'>
                  </div>

                </div>
              </div>
              <div className='CardTitle' style={{ right: '36%' }}>
                <h5>For Leo</h5>
              </div>
              <div className='CardDetails' >
                <p>Manage , create, update item here</p>
              </div>
              <div className='iconPosition' style={{ top: '-18%' }}>
                <div className='circle'>
                  <img src={item} alt='icon' style={{ width: '3rem', height: '3rem' }} />
                </div>
              </div>
              <div className='d-flex justify-content-center cardButton' >
                <h6>Create item</h6>
              </div>
            </div> */}

            {/*  */}
            {userRole === "Admin" && (
              <>
                <div
                  className="discountImage mt-5"
                  onClick={() => {
                    window.location.href = "/admin-settings";
                  }}
                >
                  <div className="discountOfferDiv">
                    <div className="discountOfferDivDetails">
                      <div className="offer-Text"></div>
                    </div>
                  </div>
                  <div className="CardTitle" style={{ right: "36%" }}>
                    <h5>Delivery</h5>
                  </div>
                  <div className="CardDetails">
                    <p>Manage, and view delivery info here</p>
                  </div>
                  <div className="iconPosition" style={{ top: "-18%" }}>
                    <div className="circle">
                      <img
                        src={delivery}
                        alt="icon"
                        style={{ width: "3rem", height: "3rem" }}
                      />
                    </div>
                  </div>
                </div>

                <div
                  className="discountImage mt-5"
                  onClick={() => {
                    window.location.href = "/admin-settings";
                  }}
                >
                  <div className="discountOfferDiv">
                    <div className="discountOfferDivDetails">
                      <div className="offer-Text"></div>
                    </div>
                  </div>
                  <div className="CardTitle" style={{ right: "26%" }}>
                    <h5>Company info</h5>
                  </div>
                  <div className="CardDetails">
                    <p>KYC, Registration, update merchant here</p>
                  </div>
                  <div className="iconPosition" style={{ top: "-18%" }}>
                    <div className="circle">
                      <img
                        src={item}
                        alt="icon"
                        style={{ width: "3rem", height: "3rem" }}
                      />
                    </div>
                  </div>
                </div>

                <div
                  className="discountImage mt-5"
                  onClick={() => {
                    window.location.href = "/admin-dashboard";
                  }}
                >
                  <div className="discountOfferDiv">
                    <div className="discountOfferDivDetails">
                      <div className="offer-Text"></div>
                    </div>
                  </div>
                  <div className="CardTitle" style={{ right: "26%" }}>
                    <h5>Settings for Leo</h5>
                  </div>
                  <div className="CardDetails">
                    <p>KYC, Registration, update merchant here</p>
                  </div>
                  <div className="iconPosition" style={{ top: "-18%" }}>
                    <div className="circle">
                      <img
                        src={settings}
                        alt="icon"
                        style={{ width: "3rem", height: "3rem" }}
                      />
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
        <div className="col-2"></div>
      </div>
      {/* <div className='d-flex justify-content-center cardSideMargin' >
    
    <div className="discountImage cardGap mt-5" >

        <img src={restaurant} alt="" className="img-fluid image-Discount" />
        <div className="discountOfferDiv ">
            <div className="discountOfferDivDetails ">
                <div className='offer-Text'>
                    <h2><b>Create restaurant</b></h2>
                </div>
                
            </div>
        </div>
    </div>
    <div className="discountImage cardGap mt-5">

        <img src={menu} alt="" className="img-fluid image-Discount" />
        <div className="discountOfferDiv ">
            <div className="discountOfferDivDetails ">
                <div className='offer-Text'>
                    <h2><b>Create menu</b></h2>
                </div>
                
            </div>
        </div>
    </div>
    <div className="discountImage ">

        <img src={restaurant} alt="" className="img-fluid image-Discount" />
        <div className="discountOfferDiv ">
            <div className="discountOfferDivDetails ">
                <div className='offer-Text'>
                    <h2><b>Create menu</b></h2>
                </div>
                
            </div>
        </div>
    </div>
   
    </div> */}

      {/* <div className='d-flex justify-content-center cardSideMargin' >
    <div className="discountImage cardGap mt-5">

        <img src={menu} alt="" className="img-fluid image-Discount" />
        <div className="discountOfferDiv ">
            <div className="discountOfferDivDetails ">
                <div className='offer-Text'>
                    <h2><b>Create restaurant</b></h2>
                </div>
                
            </div>
        </div>
    </div>
    <div className="discountImage cardGap mt-5">

        <img src={restaurant} alt="" className="img-fluid image-Discount" />
        <div className="discountOfferDiv ">
            <div className="discountOfferDivDetails ">
                <div className='offer-Text'>
                    <h2><b>Manage Order</b></h2>
                </div>
                
            </div>
        </div>
    </div>
    <div className="discountImage ">

        <img src={menu} alt="" className="img-fluid image-Discount" />
        <div className="discountOfferDiv ">
            <div className="discountOfferDivDetails ">
                <div className='offer-Text'>
                    <h2><b>Manage offer</b></h2>
                </div>
                
            </div>
        </div>
    </div>
    
    </div> */}
      {/* <div className='row'>
        <div className='col-2'></div>
        <div className='col-8 mt-3'>
          <h2>Recent order's</h2>
        </div>
        <div className='col-2'></div>
      </div>
      <div className='row'>
        <div className='col-2'></div>
        <div className='col-8'>
          <Paper sx={{ width: '100%', overflow: 'hidden' }}>
            <TableContainer sx={{ maxHeight: 440 }}>
              <Table stickyHeader aria-label="sticky table">
                <TableHead >
                  <TableRow>
                    {columns.map((column) => (
                      <TableCell
                        sx={{ backgroundColor: '#e2eaee' }}
                        key={column.id}
                        align={column.align}
                        style={{ minWidth: column.minWidth }}
                      >
                        {column.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row) => {
                      return (
                        <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                          {columns.map((column) => {
                            const value = row[column.id];
                            return (
                              <TableCell key={column.id} align={column.align}>
                                {column.format && typeof value === 'number'
                                  ? column.format(value)
                                  : value}
                                {column.id === 'button' && (
                                  <div>
                                    <button className='tableButton' style={{ backgroundColor: '#17a2b8' }} onClick={() => console.log('Button 1 clicked')}>View</button>
                                    <button className='tableButton' style={{ backgroundColor: '#dc3545' }} onClick={() => console.log('Button 2 clicked')}>Cancel</button>
                                    <button className='tableButton' style={{ backgroundColor: '#198754' }} onClick={() => console.log('Button 3 clicked')}>Accept</button>
                                  </div>
                                )}
                              </TableCell>
                            );
                          })}
                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[10, 25, 100]}
              component="div"
              count={rows.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Paper>

        </div>
        <div className='col-2'></div>
      </div> */}
    </>
  );
}

export default LandingPage;
